<template>
  <div class="electricity-statistic">
    电力统计
  </div>
</template>

<script>
export default {
  name: 'ElectricityStatistic',
  data () {
    return {
    }
  },
  watch: {
  },
  async mounted () {
  },
  methods: {
  }

}
</script>

<style lang="scss">
</style>
